import { surveyApi } from '@/api/surveyManagement'

const state = {
  surveys: []
}

const mutations = {
  SET_SURVEYS(state, surveys) {
    state.surveys = surveys
  },
  ADD_SURVEY(state, survey) {
    state.surveys.push(survey)
  },
  UPDATE_SURVEY(state, updatedSurvey) {
    const index = state.surveys.findIndex(s => s.id === updatedSurvey.id)
    if (index !== -1) {
      state.surveys.splice(index, 1, updatedSurvey)
    }
  },
  DELETE_SURVEY(state, id) {
    state.surveys = state.surveys.filter(s => s.id !== id)
  }
}

const actions = {
  async fetchSurveys({ commit, rootState }) {
    try {
      const { userRole, userDepartment, userSchool } = rootState.auth
      const surveys = await surveyApi.getAll(userRole, userDepartment, userSchool)
      commit('SET_SURVEYS', surveys)
    } catch (error) {
      console.error('Error fetching surveys:', error)
    }
  },
  async addSurvey({ commit }, survey) {
    try {
      const newSurvey = await surveyApi.create(survey)
      commit('ADD_SURVEY', newSurvey)
    } catch (error) {
      console.error('Error adding survey:', error)
    }
  },
  async updateSurvey({ commit }, survey) {
    try {
      const updatedSurvey = await surveyApi.update(survey.id, survey)
      commit('UPDATE_SURVEY', updatedSurvey)
    } catch (error) {
      console.error('Error updating survey:', error)
    }
  },
  async deleteSurvey({ commit }, id) {
    try {
      await surveyApi.delete(id)
      commit('DELETE_SURVEY', id)
    } catch (error) {
      console.error('Error deleting survey:', error)
    }
  },
  async publishSurvey({ commit }, id) {
    try {
      const updatedSurvey = await surveyApi.publish(id)
      commit('UPDATE_SURVEY', updatedSurvey)
      return updatedSurvey
    } catch (error) {
      console.error('Error publishing survey:', error)
      throw error
    }
  },
  async revokeSurvey({ commit }, id) {
    try {
      const updatedSurvey = await surveyApi.revoke(id)
      commit('UPDATE_SURVEY', updatedSurvey)
    } catch (error) {
      console.error('Error revoking survey:', error)
    }
  },
  async updateSurveyModuleDates({ commit }, { surveyId, moduleDates }) {
    try {
      const updatedSurvey = await surveyApi.updateModuleDates(surveyId, moduleDates);
      commit('UPDATE_SURVEY', updatedSurvey);
    } catch (error) {
      console.error('Error updating survey module dates:', error);
      throw error;
    }
  },
}

const getters = {
  getSurveys: state => state.surveys
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

